import { View } from "react-native";

import { DivProps } from "./Div.types";
import { useClassNames } from "../../../structure";

export default function Div({ children, classNames, id, onStartShouldSetResponder, onTouchEnd }: DivProps) {
  const style = useClassNames(classNames);
  return (
    <View id={id} style={style} onStartShouldSetResponder={onStartShouldSetResponder} onTouchEnd={onTouchEnd}>
      {children}
    </View>
  );
}
